import { render, staticRenderFns } from "./AddJobDetails.vue?vue&type=template&id=7235f3a6&scoped=true"
import script from "./AddJobDetails.vue?vue&type=script&lang=ts"
export * from "./AddJobDetails.vue?vue&type=script&lang=ts"
import style0 from "./AddJobDetails.vue?vue&type=style&index=0&id=7235f3a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235f3a6",
  null
  
)

export default component.exports